import { Component } from '@angular/core';

@Component({
  selector: 'app-external-link-stub',
  template: '' // never shown; guard will cancel before activation
})
export class ExternalLinkStubComponent {}
